import { headerSearch } from "./modules/header";
import initCtaTabs from "./blocks/cta-section-with-tabs-and-mobile-app";
import Toggle from "./modules/Toggle";
import 'flowbite';

document.addEventListener("DOMContentLoaded", function () {
  // headerSearch();
  initCtaTabs();
  new Toggle();
});
